import { render, staticRenderFns } from "./FormControlInventario.vue?vue&type=template&id=2cbd59ba&scoped=true&"
import script from "./FormControlInventario.vue?vue&type=script&lang=js&"
export * from "./FormControlInventario.vue?vue&type=script&lang=js&"
import style0 from "./FormControlInventario.vue?vue&type=style&index=0&id=2cbd59ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd59ba",
  null
  
)

export default component.exports